import { SubscriptionStatus } from 'gleblu-socket-api';

export interface Subscription {
  id: string;
  status: SubscriptionStatus;
  priceId: string;
  cancelAtPeriodEnd: boolean;
  currentPeriodEnd: string;
}

export enum SubscriptionState {
  ACTIVE = 'ACTIVE',
  UNDETERMINED = 'UNDETERMINED',
  TERMINATED = 'TERMINATED',
}

export const activeSubscriptionStatuses = [SubscriptionStatus.ACTIVE, SubscriptionStatus.TRIALING];
export const undeterminedSubscriptionStatuses = [SubscriptionStatus.INCOMPLETE, SubscriptionStatus.PAST_DUE];
export const terminatedSubscriptionStatuses = [
  SubscriptionStatus.CANCELED,
  SubscriptionStatus.UNPAID,
  SubscriptionStatus.PAUSED,
  SubscriptionStatus.INCOMPLETE_EXPIRED,
];
